<div style="padding: 20px">
  <h4>Ask your questions</h4>
  <fieldset>
<div class="row">
  <div class="col-md-12">
    <div class="form-setting__item">
      <label for="firstname" class="form-setting__label">Subject</label>
      <div class="form-setting__input d-md-flex">
        <input type="text" name="" id="firstname"  placeholder="Subject" class="form-control" /></div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="form-setting__item">
      <label for="firstname" class="form-setting__label">Question</label>
      <div class="form-setting__input d-md-flex">
        <textarea  name="query" class="form-control note-editor" rows="10"></textarea>
      </div>
    </div>
  </div>
</div>
  </fieldset>
  <div class="d-flex justify-content-end">
    <button class="btn btn-danger" type="submit">Send</button>
  </div>
</div>
